import { BundlePriceProps } from '../../../Bundles/BundlePrice/types';
import { useEffect, useState } from 'react';
import { formattingNumber } from '../../../Helper/utils/utils';
import { PokerFaceSpecialOfferButton } from './style';

const PokerFaceSpecialOfferPrice = ({
    price,
    buttonColor,
    borderColor,
    buttonTextColor,
    isFree,
    buttonText = 'Collect',
}: BundlePriceProps) => {
    const [finalPrice, setFinalPrice] = useState('');

    useEffect(() => {
        const formattedPrice = formattingNumber(
            price.price,
            price,
            price.isCents,
            price.multiplier,
            true
        );
        setFinalPrice(formattedPrice);
    }, [price]);

    return (
        <PokerFaceSpecialOfferButton
            backgroundColor={buttonColor}
            textColor={buttonTextColor}
            borderColor={borderColor}
        >
            <div className='container'>
                {isFree ? <span>{buttonText}</span> :
                    <>
                        <span>{price.currencySymbol}</span>
                        <span>{finalPrice}</span>
                    </>
                }
            </div>
        </PokerFaceSpecialOfferButton>
    );
};

export default PokerFaceSpecialOfferPrice;
